import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'


import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import ScrollAnimation from './service/scrollanimation'
Vue.directive('scrollanimation', ScrollAnimation);

import Notifications from 'vue-notification'
Vue.use(Notifications)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
